import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: JSON.parse(localStorage.getItem('dark')),
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#455A64',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFB300',
        wpp: '#25D366',
        rowsel: '#B3E5FC',
        rowerr: '#FFCDD2',
        rowsuc: '#A5D6A7',
        rowwar: '#FFF176',
        swalBkg: '#fff',
        swalText: '#545454',
        rojoDycar: '#D50000',
        disabled: '#9E9E9E',
        tab: '#E0E0E0',
        tabText: '#455A64',
        tarpen: '#FFF176',
        icon: '#138084'
      },
      dark: {
        primary: '#607D8B',
        secondary: '#212121',
        accent: '#448AFF',
        error: '#EF5350',
        info: '#42A5F5',
        success: '#66BB6A',
        warning: '#FFA726',
        wpp: '#25D366',
        rowsel: '#455A64',
        rowerr: '#531c1c',
        rowsuc: '#1B5E20',
        rowwar: '#F9A825',
        swalBkg: '#212121',
        swalText: '#fff',
        rojoDycar: '#B71C1C',
        disabled: '#9E9E9E',
        tab: '#616161',
        tabText: '#F5F5F5',
        tarpen: '#009688',
        icon: '#38a2a5'
      }
    },
  },
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    iconfont: 'fa'
  }
})
